export const ProjectsData = [
  {
    title: "Audit de votre logement",
    description:
      "Compte rendu des recommandations"
  },
  {
    title: "Reprise de vos annonces",
    description:
      "Réalisation de photos professionnelles, description, adaptée, optimisation de votre logement ( décoration, équipement, Bug, voyageurs, disponible avec un QR code ,règlement intérieur avec un QR code..)"
  },
  {
    title: "Nettoyage/blanchisserie",
    description:
      "Stock de linge (lit, serviette, torchon), pack d’arrivée, café, thé, sac poubelle, produits, vaisselle, éponge..), nettoyage et repassage du linge en interne."
  },
  {
    title: "Maintenance",
    description:
      "Intervention ponctuelle (changer une ampoule, réparer un meuble, changer les piles de la télécommande..), urgence (dégât des eaux, coupure d’électricité, et autres dommages qui nécessitent une une intervention d’urgence)",
  },
  {
    title: "Autre service sur demande",
    description:
      "Transfert disponible via un VTC, décoration spéciale (évènement, anniversaire, séminaire d’entreprise, et autres)"
  },
];
